import React from 'react';

const Overlay = (props) => {
  const { onToggle, active } = props;

  return <div className={`backdrop-overlay ${active ? 'isActive' : ''}`} onClick={() => onToggle()} data-cy="backdrop-overlay" />;
};

export default Overlay;
